import { ACTION_TRIGGER_PREFIX, } from '../types';
import { on } from '.';
import { getHotAreaNode } from '../utils/hotAreaNode';
import { componentNodeMap, getComponentNode } from '../utils/componentNode';
export function getComponentData(_a) {
    var key = _a.key, _b = _a.component, id = _b.id, info = _b.info, name = _b.name, projId = _b.projId, projKey = _b.projKey;
    return {
        key: key,
        id: id,
        info: info,
        name: name,
        projId: projId,
        projKey: projKey,
        get node() {
            return getComponentNode(key);
        },
    };
}
export function getHotAreaData(_a, component) {
    var key = _a.key, position = _a.position, size = _a.size;
    return {
        key: key,
        position: position,
        size: size,
        parent: getComponentData(component),
        get node() {
            return getHotAreaNode(key);
        },
    };
}
export function generateComponentActionParams(action, instance, global, meta) {
    var data = action.data, key = action.key, trigger = action.trigger;
    return {
        key: key,
        data: data,
        triggerEventType: trigger.replace(ACTION_TRIGGER_PREFIX, ''),
        trigger: {
            type: 'component',
            component: getComponentData(instance),
        },
        meta: meta,
        global: global,
        componentsMap: componentNodeMap,
        getComponentByKey: getComponentNode,
    };
}
export function generateHotareaActionParams(action, hotArea, component, global, meta) {
    var params = generateComponentActionParams(action, component, global, meta);
    params.trigger.type = 'hotarea';
    params.trigger.hotarea = getHotAreaData(hotArea, component);
    return params;
}
export function generatePluginParams(plugin, global, meta) {
    var key = plugin.key, data = plugin.data;
    return {
        key: key,
        data: data,
        meta: meta,
        global: global,
        on: on,
        componentsMap: componentNodeMap,
        getComponentByKey: getComponentNode,
    };
}
export function generatePluginEventListenerCallbackParams(eventType, global, meta, component, hotArea) {
    var componentData = getComponentData(component);
    var hotAreaData = hotArea ? getHotAreaData(hotArea, component) : undefined;
    return {
        meta: meta,
        global: global,
        triggerEventType: eventType,
        trigger: {
            type: hotArea ? 'hotarea' : 'component',
            component: componentData,
            hotarea: hotAreaData,
        },
        component: componentData,
        hotArea: hotAreaData,
    };
}
//# sourceMappingURL=actionParams.js.map